import React, { useState, useEffect } from 'react';

import { Row, Col, Divider, Modal, Spin, Button } from 'antd';
import { appendUTMToURL } from '../../helpers/utmTracking';


// import 'antd/dist/antd.css';
import './index.css';

import ResultsModal from './components/ResultsModal';
import UploadImage from './components/UploadImage';
import AdvancedOptions from './components/AdvancedOptions';
import MainCanvas from './components/MainCanvas';
import ColorPalette from './components/ColorPalette';
import ColorPaletteMobile from './components/ColorPaletteMobile';
import Submit from './components/Submit';
import ColorPreview from './components/ColorPreview';
import CropImage from './components/CropImage';
import TopBar from './components/TopBar';
import { t } from '../../i18n';


const ImageToSvg = () => {

    const [file, setFile] = useState("")
    const [colors, setColors] = useState([])
    const [clickedColor, setClickedColor] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isCropVisible, setIsCropVisible] = useState(false)
    const [downloadSVGLink, setDownloadSVGLink] = useState('')
    const [shareLink, setShareLink] = useState('')
    const [smoothness, setSmoothness] = useState(1)
    const [despeckle, setDespeckle] = useState(10)
    const [simplifyCurves, setSimplifyCurves] = useState(0.2)
    const [imageDimensions, setImageDimensions] = useState([0, 0])
    const [scale, setScale] = useState(1)
    const [largeImageWarning, setLargeImageWarning] = useState(false)
    const [isConvertLoading, setIsConvertLoading] = useState(false);
    const [isAIModalVisible, setIsAIModalVisible] = useState(false);
    const [isAdvancedOptionsModalVisible, setIsAdvancedOptionsModalVisible] = useState(false);


    const [crop, setCrop] = useState({
        unit: 'px', // Can be 'px' or '%'
        x: null,
        y: null,
        width: null,
        height: null
    })


    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
    });

    const setDimension = () => {
        getDimension({
            dynamicWidth: window.innerWidth,
            dynamicHeight: window.innerHeight
        })
    }


    useEffect(() => {
        window.addEventListener('resize', setDimension);

        return (() => {
            window.removeEventListener('resize', setDimension);
        })
    }, [screenSize])



    // is your image black and white? multicolor?
    if (screenSize.dynamicWidth < 750) {
        return (
            <div>


                {file === "" &&
                    <div style={{ height: 'calc(100vh)' }}>
                        <UploadImage setIsAIModalVisible={setIsAIModalVisible} setCrop={setCrop} setLargeImageWarning={setLargeImageWarning} setDespeckle={setDespeckle} setScale={setScale} setImageDimensions={setImageDimensions} setFile={setFile} setColors={setColors} />
                    </div>
                }
                {file != "" &&
                    <Spin tip={isConvertLoading ? t("Converting your image, please wait...") : t("Converting")}
                        spinning={isConvertLoading}
                    >

                        <Row hidden justify="space-between" style={{ margin: "10px" }}>
                            <ColorPreview />
                        </Row>

                        <Row>
                            <Col flex="auto" style={{ maxWidth: 'calc(100%)', height: 'calc(100vh - 130px)' }}>
                                <TopBar scale={scale} setScale={setScale} file={file} setFile={setFile} crop={crop} setIsCropVisible={setIsCropVisible} />
                                <MainCanvas crop={crop} setFile={setFile} file={file} scale={scale} setScale={setScale} setClickedColor={setClickedColor} />
                            </Col>
                        </Row>

                        <Divider style={{ margin: '0px', marginTop: '10px' }} />
                        <Row >
                        <Col style={{display: 'flex', justifyContent: 'center'}}
                            span={24} >{t("Tap the image to add colors")}</Col>
                            <Col span={24} >
                                <ColorPaletteMobile colors={colors} setColors={setColors} clickedColor={clickedColor} file={file} />
                            </Col>

  
                            <Col span={24} >
                                <Row style={{padding: '15px', width:"100%"}} 
                                
                                //add padding between buttons
                                gutter={[10, 10]}
                              >
                                    <Col 
                                        span={8}
                                    >
                                        <Button type="default" style={{  width: '100%', marginBottom: '0px', marginRight: '10px' }}
                                        onClick={() => { setIsAdvancedOptionsModalVisible(true); }}> {t("Settings")} </Button>
                                        <Modal title={t("Advanced Options")} visible={isAdvancedOptionsModalVisible} onOk={() => {
                                            setIsAdvancedOptionsModalVisible(false);
                                        }} onCancel={() => {
                                            setIsAdvancedOptionsModalVisible(false);
                                        }}>
                                            <Col span={24} >
                                                <AdvancedOptions setIsAIModalVisible={setIsAIModalVisible} imageDimensions={imageDimensions} setSmoothness={setSmoothness} setDespeckle={setDespeckle} despeckle={despeckle} setSimplifyCurves={setSimplifyCurves} />
                                            </Col>
                                        </Modal>

                                    </Col>
                                    
                                    <Col 
                                        span={16}
                                    ><Submit setIsConvertLoading={setIsConvertLoading} crop={crop} despeckle={despeckle} simplifyCurves={simplifyCurves} smoothness={smoothness} colors={colors} file={file} setIsLoading={setIsLoading} setDownloadSVGLink={setDownloadSVGLink} setShareLink={setShareLink} setIsModalVisible={setIsModalVisible} />
                                    </Col>

                                </Row>

                            </Col>
           

                        </Row>
                        <CropImage setScale={setScale} setImageDimensions={setImageDimensions} cropGlobal={crop} setCropGlobal={setCrop} largeImageWarning={largeImageWarning} file={file} isModalVisible={isCropVisible} setIsModalVisible={setIsCropVisible} downloadSVGLink={downloadSVGLink} isLoading={isLoading} />
                        {isModalVisible &&
                            <ResultsModal largeImageWarning={largeImageWarning} isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} downloadSVGLink={downloadSVGLink} shareLink={shareLink} isLoading={isLoading} />
                        }
                    </Spin>

                }
                <Modal
                    title={t("Warning: Low Resolution Image Detected")}
                    visible={isAIModalVisible}
                    okText={t("Upgrade to Pro")}
                    onOk={() => {
                        setIsAIModalVisible(false)
                        window.open(appendUTMToURL("http://pro.svgtrace.com/signup", "low-res-warning"))
                    }}
                    cancelText={t("Continue")}
                    onCancel={() => {
                        setIsAIModalVisible(false)
                    }}
                >
                    <p>{t("Your image appears to have a resolution lower than the recommended 600x600px. While our free version can still convert the image, the results may not be optimal.")} </p>
                    <p>{t("Our pro version includes AI image upscaling, which can enhance the quality of low-resolution images. We recommend upgrading to the pro version to get the best result possible.")}</p>
                </Modal>
            </div>



        )

    }
    else {
        return (
            <div>

                {file === "" &&
                    <div style={{ height: 'calc(100vh)' }}>
                        <UploadImage setIsAIModalVisible={setIsAIModalVisible} setCrop={setCrop} setLargeImageWarning={setLargeImageWarning} setScale={setScale} setDespeckle={setDespeckle} setImageDimensions={setImageDimensions} setFile={setFile} setColors={setColors} />
                    </div>
                }
                {file != "" &&
                    // <div style={{maxHeight: 'calc(100vh)'}}>
                    <Spin tip={isConvertLoading ? t("Converting your image, please wait...") : t("Converting")}
                        spinning={isConvertLoading}
                    >
                        <Row style={{ outline: "1px solid #f0f0f0", minWidth: "500px", maxHeight: 'calc(100vh)', overflow: 'hidden' }}>
                            <Col flex="auto" style={{ maxWidth: 'calc(100% - 180px)', height: '100vh' }}>
                                <TopBar scale={scale} setScale={setScale} file={file} setFile={setFile} crop={crop} setIsCropVisible={setIsCropVisible} />
                                <MainCanvas setClickedColor={setClickedColor} />
                            </Col>
                            <Col flex="180px" style={{
                                width: "180px", padding: '10px', height: '100vh',
                                // make a left border cfcfcf
                                borderLeft: '1px solid #cfcfcf',


                            }}>
                                <ColorPreview />
                                <Divider style={{ margin: '0px', marginTop: '10px' }} />
                                <ColorPalette colors={colors} setColors={setColors} clickedColor={clickedColor} file={file} />
                                <AdvancedOptions setIsAIModalVisible={setIsAIModalVisible} imageDimensions={imageDimensions} setSmoothness={setSmoothness} setDespeckle={setDespeckle} despeckle={despeckle} setSimplifyCurves={setSimplifyCurves} />
                                <Divider style={{ margin: '0px', marginTop: '10px', marginBottom: '10px' }} />
                                <Row>
                                    <Col span={24}><Submit setIsConvertLoading={setIsConvertLoading} crop={crop} despeckle={despeckle} simplifyCurves={simplifyCurves} smoothness={smoothness} colors={colors} file={file} setIsLoading={setIsLoading} setDownloadSVGLink={setDownloadSVGLink} setShareLink={setShareLink} setIsModalVisible={setIsModalVisible} /></Col>
                                </Row>






                                <CropImage setScale={setScale} setImageDimensions={setImageDimensions} cropGlobal={crop} setCropGlobal={setCrop} largeImageWarning={largeImageWarning} file={file} isModalVisible={isCropVisible} setIsModalVisible={setIsCropVisible} downloadSVGLink={downloadSVGLink} isLoading={isLoading} />
                            </Col>
                        </Row>
                    </Spin>
                }
                <Modal
                    title={t("Warning: Low Resolution Image Detected")}
                    visible={isAIModalVisible}
                    okText={t("Upgrade to Pro")}
                    onOk={() => {
                        setIsAIModalVisible(false)
                        window.open(appendUTMToURL("http://pro.svgtrace.com/signup", "low-res-warning"))
                    }}
                    cancelText={t("Continue")}
                    onCancel={() => {
                        setIsAIModalVisible(false)
                    }}
                >
                    <p>{t("Your image appears to have a resolution lower than the recommended 600x600px. While our free version can still convert the image, the results may not be optimal.")} </p>
                    <p>{t("Our pro version includes AI image upscaling, which can enhance the quality of low-resolution images. We recommend upgrading to the pro version to get the best result possible.")}</p>
                </Modal>

                {/* <Modal
                    title="Upgrade to Pro for AI Image Enhancement"
                    visible={wasAIToggled}
                    // change ok and cancel buttons
                    okText="Upgrade to Pro"
                    cancelText="Continue"
                >
                    <p>Upgrade to our pro version to access our AI image upscaling feature, which can enhance the quality of low-resolution images and give you the best result possible. Are you ready to unlock the full power of our image converter with advanced AI technology? </p>
                </Modal> */}

            </div>

        );
    }
}


export default ImageToSvg;